import Vue from 'vue'
import * as api from '@/lti/api'
import { storeEntities } from '@/students/store/helpers'

export default {
  state: {
    questions: {},
  },
  mutations: {
    ADD_QUESTIONS (state, questions) {
      storeEntities(questions, state.questions)
    },
    UPDATE_QUESTION (state, { event_id, event_state }) {
      state.questions[event_id] = event_state
    },
    REMOVE_QUESTION (state, event_id) {
      Vue.delete(state.questions, event_id)
    },
  },
  actions: {
    get_questions ({ commit, state }) {
      return api.getQuestions().then(({ data }) => {
        commit('ADD_QUESTIONS', data.object)
      })
    },
    post_question ({ commi, state }, payload) {
      return api.postQuestion(payload)
    },
    update_question ({ commit, state }, { event_id, event_state }) {
      commit('UPDATE_QUESTION', { event_id, event_state })
    },
    remove_question ({ commit, state }, { event_id }) {
      commit('REMOVE_QUESTION', event_id)
    },
  },
}
